interface RankingItem {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  trend: 'up' | 'down' | 'same';
}

const rankingItems: RankingItem[] = [
  {
    rank: 1,
    title: '顶流艺人深夜密会神秘女子，工作室发文否认',
    tag: '娱乐圈',
    heat: '986万',
    trend: 'up',
  },
  {
    rank: 2,
    title: '知名网红被曝偷税漏税，直播间已被平台关停',
    tag: '网红圈',
    heat: '872万',
    trend: 'up',
  },
  {
    rank: 3,
    title: '热门综艺录制中导师互怼，节目组疑为炒作',
    tag: '综艺圈',
    heat: '765万',
    trend: 'same',
  },
  {
    rank: 4,
    title: '某品牌代言人突然解约风波持续发酵多方回应',
    tag: '商业圈',
    heat: '654万',
    trend: 'down',
  },
  {
    rank: 5,
    title: '国外顶流歌手被曝抄袭，原唱发律师函维权',
    tag: '海外圈',
    heat: '543万',
    trend: 'up',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center mb-2">热度榜单</h2>
        <p className="text-foreground-500 text-sm text-center mb-10">实时热度排行，看看今天大家都在吃哪些瓜</p>
        <div className="flex flex-col gap-3">
          {rankingItems.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 p-4 bg-background-100 rounded-xl hover:bg-background-200/50 transition-colors duration-200 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center font-heading text-lg ${
                item.rank === 1
                  ? 'bg-primary-500 text-white'
                  : item.rank === 2
                  ? 'bg-accent-500 text-white'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-white'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-800 truncate">{item.title}</h3>
                <span className="text-xs text-foreground-400">{item.tag}</span>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="text-sm font-medium text-foreground-700">{item.heat}</span>
                <div className="w-4 h-4 flex items-center justify-center">
                  {item.trend === 'up' && <i className="ri-arrow-up-line text-sm text-primary-500"></i>}
                  {item.trend === 'down' && <i className="ri-arrow-down-line text-sm text-foreground-400"></i>}
                  {item.trend === 'same' && <i className="ri-subtract-line text-sm text-foreground-400"></i>}
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}